$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const footerSection = document.querySelectorAll('.footer-section');
        if(footerSection.length) {
            footerSection.forEach((item) => {
                let footerTitle = item.querySelector('.footer-title');
                let footerContent = item.querySelector('.footer-section--content');
                if(footerTitle && footerContent) {
                    footerTitle.addEventListener('click', () => {
                        footerTitle.classList.toggle('active');
                        footerContent.classList.toggle('active');
                    });
                }
            });
        }
    }

    document.querySelectorAll('.footer-title').forEach(title => {
        title.addEventListener('click', () => {
            // Encontra o próximo elemento irmão com a classe .footer-items
            const nextElement = title.nextElementSibling;
            if (nextElement && nextElement.classList.contains('footer-items')) {
                nextElement.classList.toggle('active'); // Alterna a classe active
            }
        });
    });
});